export enum SelectorOptionMood {
  POSITIVE,
  NEUTRAL,
  NEGATIVE,
}
